module.exports = __webpack_public_path__ + "img/car-C.60db629d.jpg";